import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CustomButton } from '../Button/Button';
import Tooltip from '../Tooltip/Tooltip';

const wrapperStyles = {
    position: 'relative',
}

const TooltipButton = ({ classNameButton, classNameTooltip, tooltipText, hoverOnDisabled = false, disabled = false, onClick, tooltipSettings, ...props }) => {
    const [isHover, setIsHover] = useState(false);
    const wrapperRef = useRef(null);


    const onMouseOver = useCallback(() => {
        tooltipText?.length && (!hoverOnDisabled || disabled) && setIsHover(true);
    }, [tooltipText, hoverOnDisabled, disabled]);

    const onMouseLeave = useCallback(() => {
        if (tooltipText?.length && (!hoverOnDisabled || disabled)) {
            setIsHover(false);
        }
    }, [tooltipText, hoverOnDisabled, disabled]);

    const handleClick = useCallback((e) => {
        // Reset hover state on click to handle cases where layout changes
        // prevent proper mouseleave events
        setIsHover(false);

        // Call original onClick if provided
        if (onClick) {
            onClick(e);
        }
    }, [onClick]);

    return (
        <div style={wrapperStyles} ref={wrapperRef}>
            <CustomButton
                className={classNameButton}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
                onClick={handleClick}
                disabled={disabled}
                {...props}
            />
            <Tooltip text={tooltipText} isHover={isHover} classNameTooltip={classNameTooltip} {...tooltipSettings} />
        </div>
    );
}

export default TooltipButton;